<template>
    <div class="outright">
        <div class="match">
            <div class="outright-marketGroup-content">
                <div
                    v-if="!outrights"
                    style=" height: 18.5rem; padding-top: 4rem;background: #fbfbfb;"
                >
                    <Spinner />
                </div>
                <template v-else>
                    <OutrightOdds
                        v-for="outright in outrights"
                        v-bind:key="`${outright.id}-${outright.isLive}`"
                        v-bind:oddsData="outright"
                        v-bind:outrightTournament="info"
                    />
                </template>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import { storeToRefs } from 'pinia';
    import type { PropType } from 'vue';
    import { defineComponent, onMounted, onUnmounted } from 'vue';
    import Spinner from '@/components/common/Spinner.vue';
    import OutrightOdds from '@/components/match/marketCard/OutrightOdds.vue';
    import type { IOutrightTournament } from '@/interface/IOutright';
    import { useOutrights } from '@/libraries/oddsApi/composables/useOutrights';
    import { useRootStore } from '@/stores/rootStore';

    export default defineComponent({
        name: 'IndiaOutright',
        components: {
            OutrightOdds,
            Spinner,
        },
        props: {
            info: {
                type: Object as PropType<IOutrightTournament>,
                required: true,
            },
        },
        setup(props) {
            const { sportType } = storeToRefs(useRootStore());

            const { outrights, refetch } = useOutrights({
                leagueId: props.info.id,
                sportType,
                isLive: props.info.isLive,
                isEnabled: true,
            });

            function refreshMatch(matchId: number, isCallApi: boolean, isLive: boolean) {
                if (matchId === props.info.id
                    && isCallApi
                    && isLive === props.info.isLive) {
                    refetch();
                }
            }

            onMounted(() => {
                window.eventEmitter.on('refreshMatch', refreshMatch);
            });

            onUnmounted(() => {
                window.eventEmitter.off('refreshMatch', refreshMatch);
            });

            return {
                outrights,
            };
        },
    });
</script>

<style lang="scss" scoped>
@import "@/scss/components/sports/marketCard/outright";
@import "@/scss/components/match";
</style>
